import React, { useCallback, useEffect } from "react";
import { getClassNameFactory } from "@dcl/ui";
import { ToastType } from "./ToastTypes";
import { DEFAULT_TOAST_DURATION_MS } from "./constants";
import InformationIcon from "./Icons/InformationIcon";
import SuccessIcon from "./Icons/SuccessIcon";
import CautionIcon from "./Icons/CautionIcon";
import WarningIcon from "./Icons/WarningIcon";
import CloseIcon from "./Icons/CloseIcon";
import Button from "../../elements/Button/Button";
import { ButtonColor, ButtonKind } from "../../elements/Button/ButtonTypes";
export var Toast = function Toast(_ref) {
  var children = _ref.children,
      id = _ref.id,
      remove = _ref.remove,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? ToastType.SUCCESS : _ref$type,
      _ref$duration = _ref.duration,
      duration = _ref$duration === void 0 ? DEFAULT_TOAST_DURATION_MS : _ref$duration,
      _ref$closeButton = _ref.closeButton,
      closeButton = _ref$closeButton === void 0 ? true : _ref$closeButton;
  var getClassName = getClassNameFactory(Toast.displayName);
  var handleRemove = useCallback(function () {
    if (remove && id) {
      remove(id);
    }
  }, [remove, id]);
  useEffect(function () {
    // eslint-disable-next-line max-statements-per-line
    if (duration === 0) {
      return;
    }

    var timeoutId = setTimeout(handleRemove, duration);
    return function () {
      return clearTimeout(timeoutId);
    };
  }, [handleRemove, duration]);
  return /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      modifiers: type
    }),
    "data-type": type
  }, /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      descendantName: "icon"
    })
  }, /*#__PURE__*/React.createElement(Icon, {
    type: type
  })), /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      descendantName: "text"
    })
  }, children), closeButton && /*#__PURE__*/React.createElement(Button, {
    color: ButtonColor.TERTIARY,
    kind: ButtonKind.BUTTON,
    onClick: handleRemove,
    "aria-label": "close toast",
    "data-testid": "closeButton"
  }, /*#__PURE__*/React.createElement(CloseIcon, null)));
};
export var Icon = function Icon(_ref2) {
  var type = _ref2.type;

  switch (type) {
    case ToastType.SUCCESS:
      return /*#__PURE__*/React.createElement(SuccessIcon, null);

    case ToastType.WARNING:
      return /*#__PURE__*/React.createElement(WarningIcon, null);

    case ToastType.CAUTION:
      return /*#__PURE__*/React.createElement(CautionIcon, null);

    case ToastType.INFO:
      return /*#__PURE__*/React.createElement(InformationIcon, null);

    default:
      return /*#__PURE__*/React.createElement(SuccessIcon, null);
  }
};
Toast.displayName = "Toast";